import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { Mapper, MapperParams } from '@products/utils/mappers/type.mapper';
import { FundId, ShareClassCode } from '@types';
import { IndexLevelsDTO } from '../dto/indexes.dto.types';
import { IndexLevels } from '../model/indexes';

export class IndexLevelsMapper extends Mapper<IndexLevels[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(indexLevelsDTO: IndexLevelsDTO[]): IndexLevels[] {
    const indexLevels: IndexLevels[] = [];

    indexLevelsDTO.forEach((indexLevelDTO) => {
      const indexLevel: IndexLevels = this.createMapper(
        IndexLevelMapper
      ).toDomain(indexLevelDTO);

      if (indexLevel) {
        indexLevels.push(indexLevel);
      }
    });

    return indexLevels;
  }
}

export class IndexLevelMapper extends Mapper<IndexLevels> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(indexLevelsDTO: IndexLevelsDTO): IndexLevels {
    return {
      fundId: indexLevelsDTO.fundid as FundId,
      shareClassCode: indexLevelsDTO.shareclasscode as ShareClassCode,
      asOfDateStd: indexLevelsDTO.asofdatestd,
      asOfDate: indexLevelsDTO.asofdate,
      indexLevel: indexLevelsDTO.indexlevel,
    };
  }
}
